




















import Vue from "vue";
import StatusTable, { CategoryData } from "@/components/Table/Status/StatusTable.vue";
import StandartCard from "@/components/Card/StandartCard/StandartCard.vue";
import DeviceCategoryModal from "@/components/Modal/Overview/DeviceCategoryModal.vue";

interface DeviceCategoryStatusData {
  should_display_category_modal: boolean;
  category_id: string | null;
}

export default Vue.extend({
  name: "Logs",
  components: { StatusTable, StandartCard, DeviceCategoryModal },
  data(): DeviceCategoryStatusData {
    return {
      should_display_category_modal: false,
      category_id: null
    };
  },
  methods: {
    shouldDisplayCategoryModal() {
      this.should_display_category_modal = true;
    },
    shouldCloseCategoryModal() {
      this.should_display_category_modal = false;
    },
    onRowClickHandler(row: CategoryData) {
      this.category_id = row._id;
      this.shouldDisplayCategoryModal();
    }
  }
});
